export const RULES_VALIDATION_CO = {
  typology: 'Tipología muy poco común en el sector',
  risk_zone: 'Inmueble en zona de riesgo',
};
export const RULES_VALIDATION_MX = {
  typology: 'tipología muy poco común en el sector',
  risk_zone: 'Inmueble en zona de riesgo',
};
